import { render, staticRenderFns } from "./RedazioneDetail.vue?vue&type=template&id=0cfc2dca"
import script from "./RedazioneDetail.vue?vue&type=script&lang=js"
export * from "./RedazioneDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports